import styled, { css } from 'styled-components';
import { mediaBreakpointMixin, mediaMixin, spaceMixin, token } from '@zillow/constellation';
import { Calendar } from 'react-big-calendar';

import type { ZCalendarEvent } from '../../constants/TourCalendar';

type StyledCalendarProps = {
  isInTourAvailabilityMode: boolean;
};

export const StyledCalendar = styled(Calendar<ZCalendarEvent>)<StyledCalendarProps>`
  &&& {
    ${(props) =>
      props.isInTourAvailabilityMode
        ? css`
            border: 1px solid #ddd;
            height: 80vh;
            ${mediaMixin(
              'md_lte',
              css`
                border-top: none;
              `,
            )}
          `
        : css`
            height: 100vh;
          `}

    overflow-y: initial !important;

    .rbc-today {
      background-color: initial;
    }

    .rbc-header.rbc-today {
      background-color: ${token('colors.blue200')};
      border-radius: 8px;
      margin-bottom: ${spaceMixin('xs')};
    }

    .rbc-allday-cell {
      display: none;
    }

    .rbc-label {
      color: #596b82;
      font-size: 12px;
    }

    // responsible for calendar outline
    .rbc-time-view {
      border: none;
    }

    .rbc-header {
      border-bottom: none;
      border-left: none;
    }

    .rbc-time-header {
      border-right: none;
    }

    .rbc-time-header-content {
      border-left: none;
    }

    .rbc-time-header-gutter {
      min-width: 79px;
    }

    .rbc-time-gutter {
      min-width: 79px;
      text-align: center;
      background-color: ${token('colors.backgroundLight')};
    }

    .rbc-timeslot-group {
      border-bottom: none;
      min-height: 100px;

      &.rbc-timeslot-group-minutes_20 {
        min-height: 150px;
      }
    }

    .rbc-day-slot {
      .rbc-time-slot {
        border-top: none;
        z-index: 1;

        &:not(.rbc-slot-past) {
          margin: 0px ${token('spacing.sm')}px;

          @media ${mediaBreakpointMixin('lg')} {
            margin: 0px ${token('spacing.xs')}px;
          }
        }

        &:hover:not(.rbc-slot-past) {
          background-color: ${token('colors.gray200')};
          border-radius: 8px;
          cursor: pointer;
        }
      }

      .rbc-slot-selection {
        background-color: ${token('colors.gray300')};
        border-radius: 8px;
        box-shadow: ${token('shadows.shadow100')};
        width: 92%;
        left: 4%;
      }
    }

    .rbc-events-container {
      margin-right: 0 !important;
    }

    .rbc-current-time-indicator {
      background-color: ${token('colors.orangeRed400')};
      height: 2px;
    }

    .rbc-time-content {
      font-family: 'Open Sans', 'Adjusted Arial', Tahoma, Geneva, sans-serif;
    }

    .rbc-event {
      border: none;
      z-index: 2;

      &.rbc-selected {
        z-index: 3;
        box-shadow: ${token('shadows.shadow100')};
      }

      &:hover {
        z-index: 3;
        box-shadow: ${token('shadows.shadow100')};
      }

      &.rbc-event-availability-event {
        background-color: ${token('colors.purple100')};
        &.rbc-selected {
          background-color: ${token('colors.purple500')};
        }
        &:not(.rbc-selected):hover {
          background-color: ${token('colors.purple200')};
        }
      }

      &.rbc-event-tour-event {
        box-shadow: ${token('shadows.shadow100')};
        background-color: ${token('colors.blue200')};
        &.rbc-selected {
          background-color: ${token('colors.blue400')};
        }
        &:not(.rbc-selected):hover {
          background-color: ${token('colors.blue300')};
        }

        &.rbc-event-tour-requested {
          background-color: ${token('colors.gray200')};
          &.rbc-selected {
            background-color: ${token('colors.gray600')};
          }
          &:not(.rbc-selected):hover {
            background-color: ${token('colors.gray300')};
          }
        }

        &.rbc-event-tour-expired {
          background-color: ${token('colors.yellow200')};
          &.rbc-selected {
            background-color: ${token('colors.yellow500')};
          }
          &:not(.rbc-selected):hover {
            background-color: ${token('colors.yellow400')};
          }
        }

        &.rbc-event-tour-cancelled {
          background-color: ${token('colors.red100')};
          &.rbc-selected {
            background-color: ${token('colors.red400')};
          }
          &:not(.rbc-selected):hover {
            background-color: ${token('colors.red200')};
          }
        }
      }
    }

    .rbc-event .calendar-event-text {
      color: ${token('colors.textDark')};
    }

    .rbc-event.rbc-selected .calendar-event-text {
      color: ${token('colors.textWhite')};
    }

    .rbc-event.rbc-event-past-event {
      opacity: 0.6;
    }

    .rbc-day-slot .rbc-slot-past {
      background-color: ${token('colors.gray100')};
    }

    .rbc-current-time-indicator .time-badge {
      position: relative;
      left: -60px;
      top: -12px;
      font-size: 12px;
      font-weight: 600;
      background-color: ${token('colors.orangeRed400')};
      padding: 2px 8px;
      border-radius: 25px;
      display: inline-block;
      color: ${token('colors.textWhite')};
    }
  }
`;
